import * as React from "react";
const SvgGrainCenter = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 128 128", contentScriptType: "text/ecmascript", ...props }, /* @__PURE__ */ React.createElement("text", { x: 37.547, y: -37.12, style: {
  fontSize: "78.82365417px",
  fill: "#0000f9",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 4.92647839,
  fontFamily: "&quot"
}, transform: "matrix(0 1.03323 -.96784 0 0 0)" }, "X"), /* @__PURE__ */ React.createElement("path", { d: "M33.085 61.831h58.576v7.051H33.085z", style: {
  fill: "#0000f9",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 8.50712585,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M58.576 39.593h7.593v52.61h-7.593z", style: {
  fill: "#0000f9",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 5,
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1
} }));
export default SvgGrainCenter;
